import request from '@/utils/request';
export const defaultSettingData = {
  id: 0,
  bankInformation: '',
  automatedCreditNoteGenerationDays: 0,
  expiryDays: 0,
  bookingAmountThreshold: 0,
  transactionPercent: 0,
  bookingPercent: 0,
  cancellationCharges: 0,
  whatsappRecipients: [],
  adminVersion: null,
  appDiscountLabel: null
};
export const getSettings = params => request({
  url: '/settings',
  method: 'get',
  params
});
export const getSettingById = id => request({
  url: `/settings/${id}`,
  method: 'get'
});
export const updateSetting = (id, data) => request({
  url: `/settings/${id}`,
  method: 'patch',
  data
});
export const deleteSetting = id => request({
  url: `/settings/${id}`,
  method: 'delete'
});
export const createSetting = data => request({
  url: '/settings/',
  method: 'post',
  data
});